<template>
    <div class="footer">
        <div class="copyright">
            <p class="pull-left sm-pull-reset">
                <span>Copyright <span class="copyright">©</span> 2020 </span>
                <span>Robotion LLC</span>.
                <span>All rights reserved. </span>
            </p>
            <p class="pull-right sm-pull-reset">
                <span>
                    <router-link to="/donate" class="m-r-10">{{ $t('site.nav.donate') }}</router-link> |
                    <router-link to="/news" class="m-l-10 m-r-10">{{ $t('site.nav.news') }}</router-link> |
                    <router-link to="/contact" class="m-l-10 m-r-10">{{ $t('site.nav.contact') }}</router-link> |
                    <router-link to="/faq" class="m-l-10 m-r-10">{{ $t('site.nav.faq') }}</router-link> |
                    <router-link to="/privacy-policy" class="m-l-10">{{ $t('site.nav.privacyPolicy') }}</router-link>
                </span>
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "elv-footer",
        components: {},
        data() {
            return {};
        }
    }
</script>

<style>
    .footer {
        bottom: 0px !important;
        margin-bottom: 0px !important;
        padding-bottom: 0px !important;
        flex-basis: unset;
        flex-shrink: unset;
    }
    a.footer { text-align: right;}
    .copyright { width: 100%; margin: 0; padding: 0;}

</style>



// WEBPACK FOOTER //
// src/components/ElvFooter.vue